/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderInventoryType {
  'Full Inventory' = 0,
  'Some Inventory' = 1,
  'Need Inventory' = 2,
}
